import { lazy, Suspense, useMemo } from 'preact/compat'
import { route } from 'preact-router'

import paths from '~/enums/paths'
import { getEntry } from '~/content/collections'
import ProjectTemplate from './projects/templates/ProjectTemplate'

// Full-page route for a single canvas experiment (/sandbox/:slug). Looks the slug up
// in the experiments collection and code-splits the body.
export default function Experiment({ slug }: { slug: string }) {
	const entry = getEntry('experiments', slug)

	const Body = useMemo(
		() => (entry ? lazy(() => entry.load()) : null),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[slug],
	)

	if (!entry || !Body) {
		route(paths.notFound, true)
		return null
	}

	return (
		<ProjectTemplate meta={entry.meta} backTo={paths.sandbox}>
			<Suspense fallback={<p className="opacity-50">Loading…</p>}>
				<Body />
			</Suspense>
		</ProjectTemplate>
	)
}
